import React, { useState, useEffect, Fragment } from 'react';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { putAPI_Delete_QuestionSet } from '../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { faPlus, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import short from 'short-uuid';
import Question from './Question';
import { Row, Collapse, Button, Card, CardBody } from 'reactstrap';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import QuestionSetForm from './QuestionSetForm'
function QuestionSet({
    set,
    index,
    loadResponse
}) {
    const [isAddQuestion, setIsAddQuestion] = useState(false);
    const [seriesName, setSeriesName] = useState(set.name);
    const [isEditing, setIsEditing] = useState(false);

    const toggleEdit = () => {
        setIsEditing(!isEditing)
    }

    const updateSet = (name) => {
        setSeriesName(name)
        toggleEdit();
    }

    const deleteSet = () => {
        let data = {
            Deleter: 'Dashboard'
        }
        try {
            AxiosAPI({
                method: 'put',
                url: `${putAPI_Delete_QuestionSet}/${set.id}`,
                data: data,
            })
                .then(() => {
                    loadResponse();
                });
        } catch (error) {
            console.error(error);
        }

    }

    return (
        <Fragment>
            <Colxx xxs="12" xs="12" style={{ border: 'solid 1px #4556ac', padding: '10px' }} className="mt-3" index={index} >
                <h3 style={{ display: 'inline-block', marginRight: '10px', color: '#922c88' }}>{seriesName}</h3>
                <FontAwesomeIcon
                    icon={faEdit}
                    color="#90caf9"
                    cursor="pointer"
                    onClick={toggleEdit}
                />
                <b> | </b>
                <FontAwesomeIcon
                    icon={faTrashAlt}
                    color="#e57373"
                    cursor="pointer"
                    onClick={() => deleteSet()}
                />
                <Collapse isOpen={isEditing}>
                    <Colxx xxs="12" className="mb-2 p-4" style={{ border: 'solid 1px #4556ac' }}>
                        <QuestionSetForm CancelQuestionSet={toggleEdit} setName={set.name} updateSet={updateSet} setId={set.id} type={set.type}
                        ></QuestionSetForm>
                    </Colxx>
                </Collapse>
                {set.questions === null && (

                    <Card className="mb-5 text-center">
                        <CardBody>
                            <Row>
                                <Colxx xxs="12" className="mb-4">
                                    <div
                                        className="content text-center">
                                        <img
                                            src={"https://bmbuiassetsprod.blob.core.windows.net/images/question.png"}
                                            alt="example"
                                            width="auto"
                                            className="img-thumbnail"
                                        />
                                    </div>
                                </Colxx>
                            </Row>
                            <Row>
                                <Colxx xxs="12" className="mb-4">
                                    <h2>First Question you will ask to start filtering</h2>
                                    <p>First question you will ask to help people filter the most relevant products & promotions for them</p>

                                </Colxx>
                            </Row>
                            <Row>
                                <Colxx xxs="12" className="mb-4">
                                    <Fragment>
                                        <div
                                            onClick={() => {
                                                setIsAddQuestion(true);
                                            }}
                                            className="mb-3"
                                        >
                                            <Button
                                                color="primary"
                                                className="add-button"
                                                size="xs"
                                                style={{ width: '100%' }}
                                            >
                                                <FontAwesomeIcon icon={faPlus} />
                                                <span> </span>
                   Ask a Question
               </Button> </div>
                                        {isAddQuestion && (
                                            <Question
                                                code={short.uuid()}
                                                index={index}
                                                loadResponse={loadResponse}
                                                setId={set.id}
                                            />)} </Fragment>
                                </Colxx>
                            </Row>
                        </CardBody>
                    </Card>
                )}
                {set.questions !== null && set.questions.map((question, index) => {
                    return (<Question code={question.code} index={index} loadResponse={loadResponse} QuestionId={question.id} Question={question} />)
                })}
                {set.questions !== null && set.questions.length > 0 && (
                    <Fragment>
                        <div
                            onClick={() => {
                                setIsAddQuestion(true);
                            }}
                            className="mb-3"
                        >
                            <Button
                                color="primary"
                                className="add-button"
                                size="xs"
                                style={{ width: '100%' }}
                            >
                                <FontAwesomeIcon icon={faPlus} />
                                <span> </span>
                   Ask a Question
               </Button> </div>
                        {isAddQuestion && (
                            <Question
                                code={short.uuid()}
                                index={index}
                                loadResponse={loadResponse}
                                setId={set.id}
                            />
                        )}
                    </Fragment>)}
            </Colxx>
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};
export default injectIntl(connect(mapStateToProps)(QuestionSet));